// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getFeaturedProducts } from "@hardwoods/App/Services/FeaturedProductsService";
import { xIsAuthenticated } from "@hardwoods/XDL/Utilities";
import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadFeaturedCategory,
    LoadProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";

type HandlerType = Parameters<typeof LoadFeaturedCategory>[0];

export const LoadFeaturedProducts = async (props: HandlerType) => {
    const {
        parameter: { carouselType },
    } = props;

    const session = getSession(props.getState());
    if (carouselType !== "featuredProducts") {
        return;
    }

    if (carouselType === "featuredProducts" && !xIsAuthenticated(session)) {
        return;
    }

    const featuredProductsIds = await getFeaturedProducts({ pageSize: props.parameter.numberOfProductsToDisplay || 8 });
    props.getProductCollectionParameter = { names: featuredProductsIds };
};

export const LoadRecentlyPurchasedProducts = (props: HandlerType) => {
    const {
        parameter: { carouselType },
    } = props;

    if (carouselType === "recentlyPurchased") {
        return false;
    }
};

export const LoadHeaderRecentlyPurchased = (props: HandlerType) => {
    const {
        parameter: { carouselType },
    } = props;
    if (carouselType !== "headerRecentlyPurchased") {
        return;
    }
    props.getProductCollectionParameter = { filter: "recentlyPurchased", pageSize: 4 };
};

export const XngExpandStyledChildren: any = (props: any) => {
    if (props.getProductCollectionParameter) {
        props.getProductCollectionParameter = {
            ...props.getProductCollectionParameter,
            expand: ["getstyledchildrencount"],
        }
    }
};


// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
addToChainAfter(chain, LoadFeaturedCategory, LoadFeaturedProducts);
addToChainAfter(chain, LoadFeaturedProducts, LoadRecentlyPurchasedProducts);
addToChainAfter(chain, LoadRecentlyPurchasedProducts, LoadHeaderRecentlyPurchased);

addToChainBefore(chain, LoadProducts, XngExpandStyledChildren)